import { useEffect } from "react";
import SEO from "../components/shared/SEO";

export default function DownloadRedirect() {
  useEffect(() => {
    const ua = navigator.userAgent.toLowerCase();

    const PLAY_STORE =
      "https://play.google.com/store/apps/details?id=com.solo_connect.app&pcampaignid=web_share";

    const APP_STORE =
      "https://apps.apple.com/in/app/soloconnect-travel-meet/id6753793984";

    if (ua.includes("android")) {
      window.location.replace(PLAY_STORE);
    } else if (
      ua.includes("iphone") ||
      ua.includes("ipad") ||
      ua.includes("ipod")
    ) {
      window.location.replace(APP_STORE);
    } else {
      console.log("Desktop detected — no redirect");
    }
  }, []);

  return (
    <div style={{ padding: 40, textAlign: "center" }}>
      <SEO
        title="Download SoloConnect App | Get Started on Android & iOS"
        description="Download the SoloConnect mobile app today to find travel partners, share trips, and explore new places with verified companions."
        keywords="download soloconnect, play store, app store, travel app download, android, ios"
      />
      Desktop detected. QR works only on mobile 📱
    </div>
  );
}
